import styled from "styled-components";

const Container = styled.div`
    width: 250px;
    height: 100dvh;
    background-color: #263B4B;
    display: flex;
    flex-direction: column;
    padding: 15px;
    box-sizing: border-box;
    flex-shrink: 0;
`
const LogoContainer = styled.div`
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    gap: 10px;
`
const LogoText = styled.p`
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    margin: 0;
`
const Logo = styled.div`
    width: 25px;
    height: 25px;
    background-color: #fff;
`
const Separator = styled.div`
    width: 100%;
    height: 1px;
    background-color: #ddd;
    margin: 15px 0;
`

const Sidebar = ({ children }) => {
    return (
        <>
            <Container>
                <LogoContainer>
                    <Logo />
                    <LogoText>PALMONT</LogoText>
                </LogoContainer>
                <Separator />
                { children }
            </Container>
        </>
    )
}

export default Sidebar;